import { render, staticRenderFns } from "./StudentAssessment.vue?vue&type=template&id=8f485e62&scoped=true"
import script from "./StudentAssessment.vue?vue&type=script&lang=js"
export * from "./StudentAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f485e62",
  null
  
)

export default component.exports